import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import '../css/Aboutus.css';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Aboutus = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="aboutus">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h1>ABOUT US</h1>
              <div className="item">
                <h5>RELIABLE</h5>
                <h5>PROFESSIONAL</h5>
                <h5>CREATIVE</h5>
              </div>
              {/* <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>RELIABLE</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h5>PROFESSIONAL</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h5>CREATIVE</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5>CREATIVE</h5>
                            </div>
                        </Carousel> */}
              <p><br></br>
                Founded in 2020 and headquartered in Los Angeles, Club Cargo is dedicated to offering comprehensive,
                <br></br>one-stop influencer marketing solutions.With a team of marketing experts spread across multiple countries,
                <br></br>our goal is to empower brands by combining professional expertise with authentic local perspectives,
                <br></br>collaborating with creators worldwide to craft unique and creative localized marketing content that resonates with global audiences.
              </p>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
      <div className="section-divider"></div>
    </section>
  )
}
